"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../../core/collapse"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../core/submit"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getDefaultState(props) {
  return {
    isOpened: false,
    newStartDate: props.competition.startDate
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Entering a new start date for the competition will move all dates by a corresponding amount. Existing entries will be retained against the new dates.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "You should only change the dates of a competition after agreement with the slalom committee.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Moving the dates now may also mean that if charged paddlers cancel out they will be refunded early and it will not be possible to reinstate them.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "DO NOT CIRCUMVENT THE DATE LIMITATION BY MOVING THE COMP TWICE. The system might let you, but it will mess up the pay outs!");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Start Date*");
var _ref6 = /*#__PURE__*/_react.default.createElement(_submit.default, null, " Set New Dates");
class ChangeCompetitionDates extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getDefaultState(this.props));
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_cancelChangeDates", () => {
      this.setState(getDefaultState(this.props));
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.props.onChangeDates(this.props.competition.id, this.state.newStartDate).then(() => {
        this.setState(getDefaultState(this.props));
      });
    });
    _defineProperty(this, "_setNewDate", newStartDate => {
      this.setState({
        newStartDate
      });
    });
  }
  render() {
    if (!this.props.userIsSystemAdmin) return null;
    const today = new Date().toISOString().split('T')[0];
    const comp = this.props.competition;
    if (comp.startDate <= today) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "reschedule-button",
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide' : 'Reschedule Competition')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card card-block"
    }, _ref, _ref2, comp.paymentsChargeDate > today && !comp.maxRescheduleDate ? null : /*#__PURE__*/_react.default.createElement(_alert.default, {
      text: "danger"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Payments were due to be charged on ", (0, _occasion.default)(comp.paymentsChargeDate, 'D MMMM YYYY'), ", so you cannot postpone the competition beyond ", (0, _occasion.default)(comp.maxRescheduleDate, 'D MMMM YYYY')), _ref3, _ref4), /*#__PURE__*/_react.default.createElement("form", {
      "data-test-id": "new-dates-form",
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "newStartDate",
      value: this.state.newStartDate,
      onChange: this._setNewDate,
      required: true
    })))), _ref6, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._cancelChangeDates
    }, "Cancel")))));
  }

  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ChangeCompetitionDates, "partials", {
  Competition: {
    id: true,
    startDate: true,
    paymentsChargeDate: true,
    maxRescheduleDate: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(ChangeCompetitionDates, undefined, (client, props) => ({
  onChangeDates(id, newStartDate) {
    return client.update('Competition.changeCompetitionDates', {
      id,
      newStartDate
    });
  }
}));